<template>
    <div class="checkout-address">
        <div ref="address_select" class="checkout-address__card">
            <div class="checkout-address__header-wrapper" @click='editAddress = true'>
                <h2 class="checkout-address__title">{{ $t("checkout.addressCardHeaderTitle") }}</h2>
                <div
                    class="text-center button-brekz button-brekz--cart button-brekz--rounded button-brekz--yellow button--icon-left text--gray-600 ml-auto"
                    @click='editAddress = !editAddress'
                >
                    <i class="fas fa-pencil-alt mr-2"></i>
                    <span class="d-none d-md-inline-block">{{ $t("myAccount.adjust") }}</span>
                </div>
            </div>
            <div class="checkout-address__body-wrapper" v-if="!editAddress">
                <div class="row" v-if="selectedAddress">
                    <div class="col-12 col-sm-4 checkout-address__information-wrapper">
                        <div class="mb-2 checkout-address__information-label-wrapper">
                            <i class="fas fa-user mr-2 d-none d-sm-inline-block checkout-address__information-label-icon"></i><span
                            class="checkout-address__information-label-text d-none d-sm-inline-block"
                        >{{
                                $t("myAccount.name")
                            }}</span>
                        </div>
                        <div class="d-flex align-items-center">
                            <i class="fas fa-user text--gray-mid d-block d-sm-none mr-4"></i>
                            <div class="account--text-cutter">{{ selectedAddress.firstname }} {{
                                    selectedAddress.lastname
                                }}
                            </div>
                        </div>

                    </div>
                    <div class="col-12 col-sm-4 checkout-address__information-wrapper">
                        <div class="mb-2 checkout-address__information-label-wrapper">
                            <i class="fas fa-home mr-2 d-none d-sm-inline-block checkout-address__information-label-icon"></i><span
                            class="checkout-address__information-label-text d-none d-sm-inline-block"
                        >{{
                                $t("myAccount.address")
                            }}</span>
                        </div>
                        <div class="d-flex  align-items-center">
                            <i class="fas fa-home text--gray-mid d-block d-sm-none mr-4"></i>
                            <div class="w-100">
                                <div class="account--text-cutter">{{
                                        selectedAddress.address1 || selectedAddress.address
                                    }}
                                    {{ selectedAddress.house_number }}
                                </div>
                                <div class="account--text-cutter">{{ selectedAddress.postcode }}, {{
                                        selectedAddress.city
                                    }}
                                </div>
                                <div v-if="selectedAddress.address2 !== ''" class="account--text-cutter">
                                    {{ selectedAddress.address2 }}
                                </div>
                                <input
                                    type="hidden"
                                    :id="`copy-address-${selectedAddress.id_address}`"
                                    :value="`${selectedAddress.address}, ${selectedAddress.postcode}, ${selectedAddress.city}`"
                                >
                            </div>
                        </div>

                    </div>
                    <div class="col-12 col-sm-4 checkout-address__information-wrapper">
                        <div class="mb-2 checkout-address__information-label-wrapper">
                            <i class="fas fa-phone mr-2 d-none d-sm-inline-block checkout-address__information-label-icon"></i><span
                            class="checkout-address__information-label-text d-none d-sm-inline-block"
                        >{{
                                $t("myAccount.phone")
                            }}</span>
                        </div>
                        <div class="d-flex align-items-center">
                            <i class="fas fa-phone text--gray-mid d-block d-sm-none mr-4"></i>
                            <div class="d-inline-block d-md-block" v-text="selectedAddress.phone"></div>
                        </div>

                    </div>
                </div>
                <div class="row" v-if="!matchingInvoiceAddress">
                    <div class="col-12 py-3">
                        <span class="checkout-address__information-title">{{ $t('checkout.invoiceAddress') }}</span>
                    </div>
                    <div class="col-12 col-sm-4 checkout-address__information-wrapper">
                        <div class="mb-2 checkout-address__information-label-wrapper">
                            <i class="fas fa-user mr-2 d-none d-sm-inline-block checkout-address__information-label-icon"></i><span
                            class="checkout-address__information-label-text d-none d-sm-inline-block"
                        >{{
                                $t("myAccount.name")
                            }}</span>
                        </div>
                        <div class="d-flex align-items-center">
                            <i class="fas fa-user text--gray-mid d-block d-sm-none mr-4"></i>
                            <div class="account--text-cutter">{{ selectedInvoiceAddress.firstname }} {{
                                    selectedInvoiceAddress.lastname
                                }}
                            </div>
                        </div>

                    </div>
                    <div class="col-12 col-sm-4 checkout-address__information-wrapper">
                        <div class="mb-2 checkout-address__information-label-wrapper">
                            <i class="fas fa-home mr-2 d-none d-sm-inline-block checkout-address__information-label-icon"></i><span
                            class="checkout-address__information-label-text d-none d-sm-inline-block"
                        >{{
                                $t("myAccount.address")
                            }}</span>
                        </div>
                        <div class="d-flex  align-items-center">
                            <i class="fas fa-home text--gray-mid d-block d-sm-none mr-4"></i>
                            <div class="w-100">
                                <div class="account--text-cutter">{{ selectedInvoiceAddress.address1 }}
                                    {{ selectedInvoiceAddress.house_number }}
                                </div>
                                <div class="account--text-cutter">{{ selectedInvoiceAddress.postcode }}, {{
                                        selectedInvoiceAddress.city
                                    }}
                                </div>
                                <div v-if="selectedInvoiceAddress.address2 !== ''" class="account--text-cutter">
                                    {{ selectedInvoiceAddress.address2 }}
                                </div>
                                <input
                                    type="hidden"
                                    :id="`copy-address-${selectedInvoiceAddress.id_address}`"
                                    :value="`${selectedInvoiceAddress.address}, ${selectedInvoiceAddress.postcode}, ${selectedInvoiceAddress.city}`"
                                >
                            </div>
                        </div>

                    </div>
                    <div class="col-12 col-sm-4 checkout-address__information-wrapper">
                        <div class="mb-2 checkout-address__information-label-wrapper">
                            <i class="fas fa-phone mr-2 d-none d-sm-inline-block checkout-address__information-label-icon"></i><span
                            class="checkout-address__information-label-text d-none d-sm-inline-block"
                        >{{
                                $t("myAccount.phone")
                            }}</span>
                        </div>
                        <div class="d-flex align-items-center">
                            <i class="fas fa-phone text--gray-mid d-block d-sm-none mr-4"></i>
                            <div class="d-inline-block d-md-block" v-text="selectedInvoiceAddress.phone"></div>
                        </div>

                    </div>
                </div>
            </div>
            <div v-else class="checkout-address__body-wrapper">
                <div class="row">
                    <div
                        class="col-12 col-md-8 offset-md-2"
                        v-if="! editDeliveryAddress && ! editInvoiceAddress && ! addNewInvoiceAddress && ! addNewAddress"
                    >
                        <span>{{ $t("checkout.addressCardHeaderTitle") }}</span>
                        <div class="checkout-address__address-select-wrapper">
                            <select
                                name="address-options"
                                class="checkout-address__address-select"
                                v-model="selectedAddress"
                            >
                                <option
                                    v-for="address in allAddresses"
                                    :value="address"
                                    v-text="`${address.address1} ${address.house_number}, ${address.city}`"
                                />
                            </select>
                        </div>
                        <div
                            v-show="!editDeliveryAddress && !addNewAddress"
                            class="checkout-address__selected-address-wrapper"
                        >
                            <ul class="checkout-address__selected-address-information">
                                <li class="checkout-address__selected-address-information-item">
                                    <i class="fas fa-user mt-1 text--gray-mid mr-4 d-md-none"></i>
                                    <span>{{
                                            selectedAddress.firstname || selectedAddress.first_name
                                        }} {{ selectedAddress.lastname || selectedAddress.last_name }}</span>
                                </li>
                                <li class="checkout-address__selected-address-information-item">
                                    <i class="fas fa-home mt-1 text--gray-mid mr-4 d-md-none"></i>
                                    <div>{{ selectedAddress.address1 || selectedAddress.address }}
                                        {{ selectedAddress.house_number }}<br/>
                                        {{ selectedAddress.postcode }}, {{ selectedAddress.city }}
                                    </div>
                                </li>
                                <li
                                    class="checkout-address__selected-address-information-item"
                                    v-if="selectedAddress.address2 !== ''"
                                >
                                    <i class="fas fa-home mt-1 text--gray-mid mr-4 d-md-none"></i>
                                    <span>{{ selectedAddress.address2 }}</span>
                                </li>
                                <li class="checkout-address__selected-address-information-item">
                                    <i class="fas fa-phone mt-1 text--gray-mid mr-4 d-md-none"></i>
                                    <span>{{ selectedAddress.phone }}</span>
                                </li>
                            </ul>
                        </div>
                        <div
                            v-show="!editDeliveryAddress && !addNewAddress"
                            class="checkout-address__selected-address-footer-wrapper"
                        >
                            <div
                                class="checkout-address__selected-address-footer-link"
                                @click="editDeliveryAddress = selectedAddress;"
                            >{{ $t('myAccount.adjust') }}
                            </div>
                            <div
                                class="checkout-address__selected-address-footer-link"
                                @click='addNewAddress = !addNewAddress'
                            >{{ $t('checkout.addNewAddress') }}
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-md-8 offset-md-2" v-if="editDeliveryAddress">
                        <checkout-address-edit
                            :address="editDeliveryAddress"
                            :countries="countries"
                            :get-address-link="getAddressLink"
                            :default-country-id="defaultCountryId"
                            @cancel-edit="editDeliveryAddress = null; editDeliveryPassesValidation = true"
                            @address-updated="getCorrectAddress"
                            @passes-validation-changed="editDeliveryPassesValidation = $event"
                        ></checkout-address-edit>
                    </div>

                    <div class="col-12 col-md-8 offset-md-2" v-if="addNewAddress">
                        <div class="row no-gutters">
                            <!-- todo: Migrate to seperate component? -->
                            <div class="col-12 checkout-address__create-new-address-header-wrapper">
                                {{ $t('checkout.addNewAddress') }}
                            </div>
                            <input-text
                                class="col-6 mb-3 pr-2 mt-3"
                                :title="$t('myAccount.firstName')"
                                :data="v$.addressData.first_name"
                                :error-text='$t("myAccount.errorFirstName")'
                                name="firstname"
                                :maxlength="32"
                                id="input_first_name"
                                v-model="addressData.first_name"
                            />

                            <input-text
                                class="col-6 mb-3 pl-2 mt-3"
                                :maxlength="32"
                                :title='$t("myAccount.lastName")'
                                :data="v$.addressData.last_name"
                                :error-text='$t("myAccount.errorLastName")'
                                name="lastname"
                                id="input_last_name"
                                v-model="addressData.last_name"
                            />

                            <input-text
                                class="mb-3"
                                :class="parseInt(addressData.id_country) !== countriesData.ID_COUNTRY_FRANCE ? 'col-9 pr-2' : 'col-12'"
                                :title='$t("myAccount.address")'
                                :maxlength="32"
                                :data="v$.addressData.address"
                                :error-text='$t("myAccount.errorAddress")'
                                :placeholder="$t('address.placeholderAddress')"
                                :replace-item="true"
                                name="address1"
                                id="input_address"
                                v-model="addressData.address"
                            />

                            <input-text
                                v-if="parseInt(addressData.id_country) !== countriesData.ID_COUNTRY_FRANCE"
                                :title='$t("myAccount.houseNumber")'
                                class="col-3 mb-3 pl-2"
                                :maxlength="5"
                                :data="v$.addressData.house_number"
                                placeholder="123 b"
                                :replace-item="true"
                                name="house_number"
                                id="input_house_number"
                                v-model="addressData.house_number"
                            />

                            <!-- Address 2 : BE, FR, DE, AT, IT -->
                            <input-text
                                v-if="addressTwoField.includes(parseInt(addressData.id_country))"
                                class="col-12 mb-3"
                                :title='$t("myAccount.address2")'
                                :maxlength="32"
                                :data="v$.addressData.address2"
                                :error-text='$t("myAccount.errorAddress2")'
                                :placeholder="$t('address.placeholderAddress2')"
                                :optional='$t("myAccount.optional")'
                                :replace-item="true"
                                name="address2"
                                id="input_address"
                                v-model="addressData.address2"
                            />

                            <input-text
                                class="col-5 mb-3 pr-2"
                                :title='$t("myAccount.zipcode")'
                                :data="v$.addressData.postcode"
                                :error-text='$t("myAccount.errorZipcode")'
                                :placeholder="addressData.id_country === 19 ? '1234' : $t('address.placeholderZipcode')"
                                name="postcode"
                                :maxlength="6"
                                id="input_postcode"
                                v-model="addressData.postcode"
                            />

                            <input-text
                                class="col-7 mb-3 pl-2"
                                :title='$t("myAccount.residence")'
                                :data="v$.addressData.city"
                                :error-text='$t("myAccount.errorCity")'
                                :placeholder="addressData.id_country === 19 ? 'Bern' : $t('address.placeholderCity')"
                                name="city"
                                :maxlength="32"
                                id="input_city"
                                v-model="addressData.city"
                            />

                            <div
                                class="col-12 mb-3"
                                v-show="addressData.id_country === countriesData.ID_COUNTRY_NETHERLANDS || addressData.id_country === countriesData.ID_COUNTRY_FRANCE || addressData.id_country === countriesData.ID_COUNTRY_LUXEMBOURG"
                            >
                                <div>{{ $t("myAccount.country") }}</div>
                                <select
                                    name="id_country"
                                    id="input_country_addressCreate"
                                    v-model="addressData.id_country"
                                    class="input-select--country"
                                    :value="addressData.id_country"
                                    v-on:change="checkCountry()"
                                >
                                    <option
                                        v-for="country in countries"
                                        :value="parseInt(country.id_country)"
                                    >{{ country.name }}
                                    </option>
                                </select>
                            </div>

                            <input-text
                                class="col-12 mb-3"
                                :title='$t("myAccount.phoneNumber")'
                                :data="v$.addressData.phone"
                                :error-text='$t("myAccount.errorPhone")'
                                :sub-text='$t("myAccount.phoneNumberMessage")'
                                :placeholder='$t("address.placeholderPhone")'
                                :maxlength="32"
                                inputType="number"
                                name="phone"
                                id="input_phone"
                                @keyup.enter.prevent="submitForm()"
                                v-model="addressData.phone"
                            />

                            <div v-show="errorBag.length" class="col-12 mt-3 text--sm">
                                <i class="fas fa-times-circle text-danger mr-2"></i>
                                <span class="text-danger font-weight-bold">{{ $t("myAccount.errorMessage") }}</span>

                                <div v-for="error in errorBag" id="opc_login_errors">
                                    <div class="text-danger ml-4" v-text="'- '+ getValidationError(error.name, error.type)"></div>
                                </div>
                            </div>
                            <div class="text-danger text--sm" v-if="!passesValidation" id="opc_account_errors">

                            </div>

                            <div class="py-4 account__card--bottom-bar align-items-center ml-auto">
                                <div class="button button--clear m-0" @click="cancelCheck()">{{
                                        $t("myAccount.cancel")
                                    }}
                                </div>
                                <div
                                    class="button-brekz button-brekz--rounded button-brekz--lg m-0 text-center"
                                    :class="{'button-brekz--green': !isSubmitting || !errorBag.length}"
                                    @click="submitForm()"
                                >
                                    <img
                                        v-if="isSubmitting"
                                        class="mx-auto"
                                        style="height: 25px;"
                                        src="/themes/brekz-2017/img/loading-indicator-l.gif"
                                    >
                                    <div v-else>{{ $t("myAccount.save") }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="col-12 py-3"
                        v-if="(! editDeliveryAddress && ! editInvoiceAddress && ! addNewAddress && ! addNewInvoiceAddress)"
                    >
                        <div class="checkout-address__switch-wrapper">
                            <label class="switch checkout-address__toggle-wrapper">
                                <input type="checkbox" checked v-model="matchingInvoiceAddress">
                                <span class="checkout-address__toggle checkout-address__toggle--round"></span>
                            </label>
                            <div class="checkout-address__toggle-label-text" v-if="matchingInvoiceAddress">
                                {{ $t('checkout.addressMatchesInvoiceAddress') }}
                            </div>
                            <div
                                class="checkout-address__toggle-label-text checkout-address__toggle-label-text--disabled"
                                v-else
                            >{{ $t('checkout.addressMatchesNotInvoiceAddress') }}
                            </div>
                        </div>
                    </div>
                    <template v-if="!matchingInvoiceAddress && (! editDeliveryAddress && ! addNewAddress)">
                        <div class="col-12 col-md-8 offset-md-2" v-if="! editInvoiceAddress && ! addNewInvoiceAddress">
                            <span>{{ $t('checkout.invoiceAddress') }}</span>
                            <div class="checkout-address__address-select-wrapper">
                                <select
                                    name="invoice-address-options"
                                    class="checkout-address__address-select"
                                    v-model="selectedInvoiceAddress"
                                >
                                    <option
                                        v-for="address in allAddresses"
                                        :value="address"
                                        v-text="`${address.address1} ${address.house_number}, ${address.city}`"
                                    />
                                </select>
                            </div>
                            <div class="checkout-address__selected-address-wrapper">
                                <ul class="checkout-address__selected-address-information">
                                    <li class="checkout-address__selected-address-information-item">
                                        <i class="fas fa-user mt-1 text--gray-mid mr-4 d-md-none"></i>
                                        <span>{{ selectedInvoiceAddress.firstname }} {{
                                                selectedInvoiceAddress.lastname
                                            }}</span>
                                    </li>
                                    <li class="checkout-address__selected-address-information-item">
                                        <i class="fas fa-home mt-1 text--gray-mid mr-4 d-md-none"></i>
                                        <div>{{ selectedInvoiceAddress.address1 }}
                                            {{ selectedInvoiceAddress.house_number }}<br/>
                                            {{ selectedInvoiceAddress.postcode }}, {{ selectedInvoiceAddress.city }}
                                        </div>
                                    </li>
                                    <li
                                        class="checkout-address__selected-address-information-item"
                                        v-if="selectedInvoiceAddress.address2 !== ''"
                                    >
                                        <i class="fas fa-home mt-1 text--gray-mid mr-4 d-md-none"></i>
                                        <span>{{ selectedInvoiceAddress.address2 }}</span>
                                    </li>
                                    <li class="checkout-address__selected-address-information-item">
                                        <i class="fas fa-phone mt-1 text--gray-mid mr-4 d-md-none"></i>
                                        <span>{{ selectedInvoiceAddress.phone }}</span>
                                    </li>
                                </ul>
                            </div>
                            <div class="checkout-address__selected-address-footer-wrapper">
                                <div
                                    class="checkout-address__selected-address-footer-link"
                                    @click="editInvoiceAddress = selectedInvoiceAddress;"
                                >{{ $t('checkout.editAddress') }}
                                </div>
                                <div
                                    class="checkout-address__selected-address-footer-link"
                                    @click='addNewInvoiceAddress = !addNewInvoiceAddress'
                                >{{ $t('checkout.addNewAddress') }}
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-md-8 offset-md-2" v-if="editInvoiceAddress">
                            <checkout-address-edit
                                :address="editInvoiceAddress"
                                :countries="countries"
                                :get-address-link="getAddressLink"
                                :default-country-id="defaultCountryId"
                                @cancel-edit="editInvoiceAddress = null; editInvoicePassesValidation = true"
                                @address-updated="getCorrectAddress"
                                @passes-validation-changed="editInvoicePassesValidation = $event"
                            ></checkout-address-edit>
                        </div>

                        <div class="col-12 col-md-8 offset-md-2" v-if="addNewInvoiceAddress">
                            <div class="row no-gutters">
                                <div class="col-12 checkout-address__create-new-address-header-wrapper">
                                    {{ $t('checkout.addNewInvoiceAddress') }}
                                </div>
                                <input-text
                                    class="col-6 mb-3 pr-2 mt-3"
                                    :title="$t('myAccount.firstName')"
                                    :data="v$.addressData.first_name"
                                    :error-text='$t("myAccount.errorFirstName")'
                                    name="firstname"
                                    :maxlength="32"
                                    id="input_first_name"
                                    v-model="addressData.first_name"
                                />

                                <input-text
                                    class="col-6 mb-3 pl-2 mt-3"
                                    :maxlength="32"
                                    :title='$t("myAccount.lastName")'
                                    :data="v$.addressData.last_name"
                                    :error-text='$t("myAccount.errorLastName")'
                                    name="lastname"
                                    id="input_last_name"
                                    v-model="addressData.last_name"
                                />

                                <input-text
                                    class="mb-3"
                                    :class="parseInt(addressData.id_country) !== countriesData.ID_COUNTRY_FRANCE ? 'col-9 pr-2' : 'col-12'"
                                    :title='$t("myAccount.address")'
                                    :maxlength="32"
                                    :data="v$.addressData.address"
                                    :error-text='$t("myAccount.errorAddress")'
                                    :placeholder="$t('address.placeholderAddress')"
                                    :replace-item="true"
                                    name="address1"
                                    id="input_address"
                                    v-model="addressData.address"
                                />

                                <input-text
                                    v-if="parseInt(addressData.id_country) !== countriesData.ID_COUNTRY_FRANCE"
                                    :title='$t("myAccount.houseNumber")'
                                    class="col-3 mb-3 pl-2"
                                    :maxlength="5"
                                    :data="v$.addressData.house_number"
                                    placeholder="123 b"
                                    :replace-item="true"
                                    name="house_number"
                                    id="input_house_number"
                                    v-model="addressData.house_number"
                                />

                                <!-- Address 2 : BE, FR, DE, AT, IT -->
                                <input-text
                                    v-if="addressTwoField.includes(parseInt(addressData.id_country))"
                                    class="col-12 mb-3"
                                    :title='$t("myAccount.address2")'
                                    :maxlength="32"
                                    :data="v$.addressData.address2"
                                    :error-text='$t("myAccount.errorAddress2")'
                                    :placeholder="$t('address.placeholderAddress2')"
                                    :optional='$t("myAccount.optional")'
                                    :replace-item="true"
                                    name="address2"
                                    id="input_address"
                                    v-model="addressData.address2"
                                />

                                <input-text
                                    class="col-5 mb-3 pr-2"
                                    :title='$t("myAccount.zipcode")'
                                    :data="v$.addressData.postcode"
                                    :error-text='$t("myAccount.errorZipcode")'
                                    :placeholder="addressData.id_country === 19 ? '1234' : $t('address.placeholderZipcode')"
                                    name="postcode"
                                    :maxlength="6"
                                    id="input_postcode"
                                    v-model="addressData.postcode"
                                />

                                <input-text
                                    class="col-7 mb-3 pl-2"
                                    :title='$t("myAccount.residence")'
                                    :data="v$.addressData.city"
                                    :error-text='$t("myAccount.errorCity")'
                                    :placeholder="addressData.id_country === 19 ? 'Bern' : $t('address.placeholderCity')"

                                    name="city"
                                    :maxlength="32"
                                    id="input_city"
                                    v-model="addressData.city"
                                />

                                <div
                                    class="col-12 mb-3"
                                    v-show="addressData.id_country === countriesData.ID_COUNTRY_NETHERLANDS || addressData.id_country === countriesData.ID_COUNTRY_FRANCE || addressData.id_country === countriesData.ID_COUNTRY_LUXEMBOURG"
                                >
                                    <div>{{ $t("myAccount.country") }}</div>
                                    <select
                                        name="id_country"
                                        id="input_country_addressCreate"
                                        v-model="addressData.id_country"
                                        class="input-select--country"
                                        :value="addressData.id_country"
                                        v-on:change="checkCountry()"
                                    >
                                        <option
                                            v-for="country in countries"
                                            :value="parseInt(country.id_country)"
                                        >{{ country.name }}
                                        </option>
                                    </select>
                                </div>

                                <input-text
                                    class="col-12 mb-3"
                                    :title='$t("myAccount.phoneNumber")'
                                    :data="v$.addressData.phone"
                                    :error-text='$t("myAccount.errorPhone")'
                                    :sub-text='$t("myAccount.phoneNumberMessage")'
                                    :placeholder='$t("address.placeholderPhone")'
                                    :maxlength="32"
                                    inputType="number"
                                    name="phone"
                                    id="input_phone"
                                    @keyup.enter.prevent="submitForm()"
                                    v-model="addressData.phone"
                                />

                                <div v-show="errorBag.length" class="col-12 mt-3 text--sm">
                                    <i class="fas fa-times-circle text-danger mr-2"></i>
                                    <span class="text-danger font-weight-bold">{{ $t("myAccount.errorMessage") }}</span>

                                    <div v-for="error in errorBag" id="opc_login_errors">
                                        <div class="text-danger ml-4" v-text="'- '+ getValidationError(error.name, error.type)"></div>
                                    </div>
                                </div>
                                <div class="text-danger text--sm" v-if="!passesValidation" id="opc_account_errors">

                                </div>

                                <div class="py-4 account__card--bottom-bar align-items-center ml-auto">
                                    <div class="button button--clear m-0" @click="cancelCheck()">
                                        {{ $t("myAccount.cancel") }}
                                    </div>
                                    <div
                                        class="button-brekz button-brekz--rounded button-brekz--lg m-0 text-center"
                                        :class="{'button-brekz--green': !isSubmitting || !errorBag.length}"
                                        @click="submitForm()"
                                    >
                                        <img
                                            v-if="isSubmitting"
                                            class="mx-auto"
                                            style="height: 25px;"
                                            src="/themes/brekz-2017/img/loading-indicator-l.gif"
                                        >
                                        <div v-else>{{ $t("myAccount.save") }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
            <div
                class="checkout-address__footer-wrapper checkout-address__footer-wrapper--buttons"
                v-if="editAddress && (!editDeliveryAddress && !editInvoiceAddress && !addNewAddress && !addNewInvoiceAddress)"
            >
                <div
                    class="button-brekz button-brekz--rounded button-brekz--lg m-0 text-center"
                    @click="collapseAddressBlock"
                >
                    <img
                        v-if="isSubmitting"
                        class="mx-auto"
                        style="height: 25px;"
                        src="/themes/brekz-2017/img/loading-indicator-l.gif"
                    >
                    <div v-else class="d-flex">
                        {{ $t("myAccount.close") }}
                        <i class="fas fa-chevron-up ml-3 my-auto"></i>
                    </div>
                </div>
            </div>
            <div class="checkout-address__footer-wrapper checkout-address__footer-wrapper--note" v-else>
                <div class="checkout-address__footer-note" v-if="matchingInvoiceAddress">
                    <i class="fas fa-check checkout-address__footer-note-icon"></i>
                    <span>{{ $t("checkout.addressMatchesInvoiceAddress") }}</span>
                </div>
                <div class="checkout-address__footer-note checkout-address__footer-note--disabled" v-else>
                    <i class="fas fa-times checkout-address__footer-note-icon checkout-address__footer-note-icon--disabled"></i>
                    <span>{{ $t("checkout.addressMatchesNotInvoiceAddress") }}</span>
                </div>
            </div>
        </div>
        <modal-vue
            type="confirm"
            :show="showCancelWarning"
            @confirm="cancelEdit()"
            @cancel="closeModal()"
            title="Verwijderen"
            width="xs"
            :buttons="addressCreateCancelButtons"
        >
            <p class="my-4">{{ $t("myAccount.eraseWarning") }}<br/><br/>{{ $t("myAccount.eraseConfirmation") }}</p>
        </modal-vue>
    </div>
</template>

<script>
import ModalVue from "../ModalVue";
import InputText from "../Address/InputText";
import validationRules from '../../js/validation/rules';
import getError from '../../js/validation/getError';
import CheckoutAddressEdit from "./CheckoutAddressEdit";
import axios from "axios";

import useVuelidate from "@vuelidate/core";
import { maxLength, required, requiredIf } from '@vuelidate/validators'

const addressTwoField = [
    ID_COUNTRY_NETHERLANDS,
    ID_COUNTRY_GERMANY,
    ID_COUNTRY_AUSTRIA,
    ID_COUNTRY_SWITZERLAND,
    ID_COUNTRY_FRANCE,
    ID_COUNTRY_ITALY,
    ID_COUNTRY_BELGIUM,
    ID_COUNTRY_DENMARK,
];

const ID_COUNTRY_GERMANY     = 1;
const ID_COUNTRY_AUSTRIA     = 2;
const ID_COUNTRY_BELGIUM     = 3;
const ID_COUNTRY_FRANCE      = 8;
const ID_COUNTRY_ITALY       = 10;
const ID_COUNTRY_LUXEMBOURG  = 12;
const ID_COUNTRY_NETHERLANDS = 13;
const ID_COUNTRY_SWITZERLAND = 19;
const ID_COUNTRY_DENMARK     = 20;

export const TYPE_ACCOUNT          = 'account';
export const TYPE_CHECKOUT         = 'checkout';
export const TYPE_CHECKOUT_ADDRESS = 'checkout-address';

export const CustomValues = {
    checkout: {
        title: 'checkout.newAccount',
    },
    account: {
        title: 'myAccount.addAddress'
    },
    'checkout-address': {
        title: 'myAccount.addAddress'
    }
};

export default {
    name: "CheckoutAddress",
    props: {
        addresses: Array,
        idLang: Number,
        idShop: Number,
        idAddressDelivery: Number,
        idAddressInvoice: Number,
        addNewAddressLink: String,
        countries: Array,
        defaultCountryId: Number,
        addressCopyData: Object,
        getAddressLink: {
            required: false,
            type: String,
        },
        backLink: {
            required: false,
            type: String,
        },
        changeOrderAddressLink: {
            required: false,
            type: String,
        }
    },
    components: {
        CheckoutAddressEdit,
        ModalVue,
        InputText
    },
    setup () {
        return { v$: useVuelidate() }
    },
    data() {
        return {
            allAddresses: this.addresses,
            editAddress: false,
            previousSelectedAddress: null,
            previousSelectedInvoiceAddress: null,
            previousMatchingInvoiceAddress: false,
            selectedAddress: null,
            selectedInvoiceAddress: null,
            matchingInvoiceAddress: true,
            addNewAddress: false,
            addNewInvoiceAddress: false,
            editDeliveryAddress: null,
            editInvoiceAddress: null,
            editDeliveryPassesValidation: true,
            editInvoicePassesValidation: true,
            addressData: {
                first_name: '',
                last_name: '',
                address: '',
                house_number: '',
                address2: '',
                postcode: '',
                city: '',
                id_country: this.defaultCountryId,
                phone: '',
                default_address: false,
                password: '',
                email: '',
            },
            TYPE_ACCOUNT: TYPE_ACCOUNT,
            TYPE_CHECKOUT: TYPE_CHECKOUT,
            TYPE_CHECKOUT_ADDRESS: TYPE_CHECKOUT_ADDRESS,
            countriesData: {
                ID_COUNTRY_GERMANY: ID_COUNTRY_GERMANY,
                ID_COUNTRY_AUSTRIA: ID_COUNTRY_AUSTRIA,
                ID_COUNTRY_BELGIUM: ID_COUNTRY_BELGIUM,
                ID_COUNTRY_FRANCE: ID_COUNTRY_FRANCE,
                ID_COUNTRY_ITALY: ID_COUNTRY_ITALY,
                ID_COUNTRY_LUXEMBOURG: ID_COUNTRY_LUXEMBOURG,
                ID_COUNTRY_NETHERLANDS: ID_COUNTRY_NETHERLANDS,
                ID_COUNTRY_DENMARK: ID_COUNTRY_DENMARK,
                ID_COUNTRY_SWITZERLAND: ID_COUNTRY_SWITZERLAND,
            },
            addressTwoField: addressTwoField,
            CustomValues: CustomValues,
            showCancelWarning: false,
            isSubmitting: false,
            addressCreateCancelButtons: [
                {
                    text: this.$t('myAccount.cancel'),
                    class: "",
                    emit_name: "cancel"
                },
                {
                    text: this.$t('myAccount.delete'),
                    class: "button--extra-large button-brekz button-brekz--rounded button-brekz--yellow",
                    emit_name: "confirm"
                }
            ]
        };
    },
    validations: {
        addressData: {
            first_name: {
                required,
                maxlength: maxLength(32),
            },
            last_name: {
                required,
                maxlength: maxLength(32),
            },
            address: {
                required,
                validateAddress: validationRules.address,
                maxlength: maxLength(32),
            },
            house_number: {
                required: requiredIf(function() {
                    return this.addressData.id_country !== this.countriesData.ID_COUNTRY_FRANCE;
                }),
                maxlength: maxLength(5),
                validateHouseNumber: validationRules.houseNumber,
            },
            address2: {
                maxlength: maxLength(128),
            },
            postcode: {
                required,
                validateZipCode: validationRules.zipCode
            },
            city: {
                required,
                validateCity: validationRules.city
            },
            phone: {
                validatePhone: validationRules.phone
            },
        }
    },
    computed: {
        defaultAddress() {
            return this.allAddresses[0];
        },
        errorBag() {
            if (! this.v$.addressData) {
                return [];
            }

            return this.v$
                       .addressData
                       .$errors
                       .map((error) => ({
                           name: error.$property,
                           type: error.$validator,
                           error: error.$message
                       }));
        },
        passesValidation() {
            return (
                this.errorBag.length === 0 &&
                this.editDeliveryPassesValidation &&
                this.editInvoicePassesValidation &&
                this.selectedAddress &&
                !this.selectedAddress.no_shipping &&
                !this.isSubmitting
            );
        }
    },
    created() {
        window.EventBus.$on('checkout-address-refresh-addresses-list', () => {
            this.getAllAddresses();
        });
    },
    mounted() {
        this.selectedAddress        = this.defaultAddress;
        this.selectedInvoiceAddress = this.selectedAddress;

        if (this.idAddressDelivery) {
            this.setDeliveryAddressByAddressId(this.idAddressDelivery);
        }

        if (this.selectedInvoiceAddress) {
            this.setInvoiceAddressByAddressId(this.idAddressInvoice);
        }

        this.matchingInvoiceAddress = this.idAddressDelivery === this.idAddressInvoice;

        if (this.selectedAddress) {
            this.previousSelectedAddress        = JSON.parse(JSON.stringify(this.selectedAddress));
        }

        if (this.selectedInvoiceAddress) {
            this.previousSelectedInvoiceAddress = JSON.parse(JSON.stringify(this.selectedInvoiceAddress));
        }

        if (this.matchingInvoiceAddress) {
            this.previousMatchingInvoiceAddress = JSON.parse(JSON.stringify(this.matchingInvoiceAddress));
        }
    },
    methods: {
        pushGAEvent(event, data) {
            if (typeof window.pushGAEvent === 'function') {
                window.pushGAEvent(event, data);
            }
        },
        setDeliveryAddressByAddressId(addressId) {
            const addressIndex = this.allAddresses.findIndex((address) => address.id_address == addressId);

            if (addressIndex !== -1) {
                this.selectedAddress = this.allAddresses[addressIndex];
            }
        },
        setInvoiceAddressByAddressId(addressId) {
            const addressIndex = this.allAddresses.findIndex((address) => address.id_address == addressId);

            if (addressIndex !== -1) {
                this.selectedInvoiceAddress = this.allAddresses[addressIndex];
            }
        },
        jsGetBack() {
            if (this.backLink) {
                window.location.href = this.backLink;
                return true;
            }

            window.history.back();
            return true;
        },
        getCorrectAddress(idAddress) {
            this.getAllAddresses();
            this.editInvoiceAddress  = null;
            this.editDeliveryAddress = null;
            this.$refs.address_select.scrollIntoView({ behavior: 'smooth', block: 'center' });
        },
        getAllAddresses() {
            const oldDeliveryAddressId = this.selectedAddress ? this.selectedAddress.id_address : null;
            const oldInvoiceAddressId  = this.selectedInvoiceAddress ? this.selectedInvoiceAddress.id_address : null;

            axios.put(`${this.getAddressLink}?action=all`)
                 .then((response) => {
                     const { data }      = response;
                     const { addresses } = data;

                     addresses.forEach((address, index) => {
                         addresses[index].firstname = addresses[index].first_name;
                         addresses[index].lastname  = addresses[index].last_name;
                         addresses[index].address1  = addresses[index].address;

                         delete addresses[index].first_name;
                         delete addresses[index].last_name;
                         delete addresses[index].address;
                     });

                     this.allAddresses             = addresses;
                     const foundOldDeliveryAddress = addresses.find((address) => address.id_address === oldDeliveryAddressId);
                     const foundInvoiceAddress     = addresses.find((address) => address.id_address === oldInvoiceAddressId);

                     this.$emit('addresses-list-changed', addresses);

                     if (!foundOldDeliveryAddress) {
                         this.selectedAddress = addresses[0];
                     }

                     if (!foundInvoiceAddress) {
                         this.selectedInvoiceAddress = addresses[0];
                     }

                     if (oldDeliveryAddressId) {
                         this.setDeliveryAddressByAddressId(oldDeliveryAddressId);
                     }

                     if (oldInvoiceAddressId) {
                         this.setInvoiceAddressByAddressId(oldInvoiceAddressId);
                     }
                 })

                 .catch((error) => {
                     this.$emit('error-occurred');
                     console.log('getting addresses failed', error);
                 });
        },
        getValidationError(name, type) {
            return getError(name, type);
        },
        checkValidate() {
            this.v$.$touch();

            if (this.v$.$invalid) {
                return;
            }

            this.isSubmitting = true;
        },
        submitForm() {
            this.v$.$touch();

            if (this.v$.$invalid) {
                return;
            }

            this.isSubmitting = true;

            this.addressData.postcode = this.addressData.postcode.replace(' ', '');

            jQuery.ajax(`${this.getAddressLink}?action=create`, {
                type: "POST",
                data: JSON.stringify(this.addressData),
                success: response => {
                    if (this.addressData.default_address === true) {
                        this.$emit('default-address-changed', {
                            id_address: response.address.id_address,
                            changed_to: this.addressData.default_address
                        });
                    }
                    this.$emit('new-address-data', { addressData: this.addressData });

                    if (this.addNewAddress) {
                        this.selectedAddress = response.address;
                    }

                    if (this.addNewInvoiceAddress) {
                        this.selectedInvoiceAddress = response.address;
                    }

                    this.isSubmitting         = false;
                    this.addNewAddress        = false;
                    this.addNewInvoiceAddress = false;
                    this.getAllAddresses();

                    this.changeOrderAddress();
                },
                error: XMLHttpRequest => {
                    this.$emit('error-occurred');
                    console.log('Create address failed', XMLHttpRequest.responseText);
                    this.isSubmitting = false;
                }
            });


        },
        setNoShippingOrUpliftMessage(address) {
            const carrierUplift       = document.getElementById('address_carrier_uplift');
            const carrierUpliftMobile = document.getElementById('address_carrier_uplift_mobile');
            const noShipping          = document.getElementById('address_no_shipping');
            const noShippingMobile    = document.getElementById('address_no_shipping_mobile');

            if (address.no_shipping === true && noShipping) {
                noShipping.style.display = 'block';
                noShippingMobile.style.display = 'block';
            }

            if (address.carrier_uplift && carrierUplift) {
                carrierUplift.style.display = 'block';
                carrierUplift.innerText = this.$i18n.t('address.noShipping');
            }

            if (address.carrier_uplift && carrierUpliftMobile) {
                carrierUpliftMobile.style.display = 'block';
                carrierUpliftMobile.innerText = this.$i18n.t('address.noShipping');
            }
        },
        unsetShippingMessages() {
           const carrierUplift = document.getElementById('address_carrier_uplift');
           const noShipping = document.getElementById('address_no_shipping');

           if (carrierUplift) {
               carrierUplift.style.display = 'none';
           }

           if (noShipping) {
               noShipping.style.display = 'none';
           }
        },
        changeOrderAddress() {
            if (this.isSubmitting) {
                return;
            }

            this.isSubmitting = true;

            jQuery.ajax(`${this.changeOrderAddressLink}`, {
                type: "POST",
                data: {
                    ajax: true,
                    id_address_delivery: this.selectedAddress.id_address,
                    id_address_invoice: this.matchingInvoiceAddress ? this.selectedAddress.id_address : this.selectedInvoiceAddress.id_address
                },
                success: response => {
                    this.isSubmitting = false;

                    response = JSON.parse(response);

                    if  (response.summary && document.getElementById('cart_shipping')) {

                        if  (response.summary.total_shipping === 0) {
                            document.getElementById('cart_shipping').innerText = this.$t('myAccount.freeOfCharge');
                        } else {
                            document.getElementById('cart_shipping').innerText = response.summary.total_shipping_display;
                        }

                    }


                    if (this.selectedAddress) {
                        this.previousSelectedAddress        = JSON.parse(JSON.stringify(this.selectedAddress));
                    }

                    if (this.selectedInvoiceAddress) {
                        this.previousSelectedInvoiceAddress = JSON.parse(JSON.stringify(this.selectedInvoiceAddress));
                    }

                    if (this.matchingInvoiceAddress) {
                        this.previousMatchingInvoiceAddress = JSON.parse(JSON.stringify(this.matchingInvoiceAddress));
                    }

                    this.$refs.address_select.scrollIntoView({ behavior: 'smooth', block: 'center' });
                },
                error: XMLHttpRequest => {
                    // todo: Feedback geven aan de gebruiker over de foutmelding
                    // this.$emit('error-occurred');
                    // console.log('Create address failed', XMLHttpRequest.responseText);
                    this.isSubmitting = false;
                }
            });
        },
        collapseAddressBlock() {
            this.editAddress = false;
        },
        closeEditCollapse() {
            this.addNewAddress        = false;
            this.addNewInvoiceAddress = false;
        },
        cancelEdit() {
            document.body.classList.remove("modal-vue--open");
            this.showCancelWarning = false;
            this.clearFormData();
            this.closeEditCollapse();
        },
        closeModal() {
            this.showCancelWarning = false;
            this.closeEditCollapse();
            document.body.classList.remove("modal-vue--open");

        },
        checkCountry() {
            if ($('#input_country_addressCreate').val() === '13') {
                $('#input_zipcode_addressCreate').attr('placeholder', '1234AB').focus().blur();
            }
            if ($('#input_country_addressCreate').val() === '3') {
                $('#input_zipcode_addressCreate').attr('placeholder', '1234').focus().blur();
            }

        },
        cancelCheck() {
            if ($('[id^="input_"]').val() === '') {
                this.closeEditCollapse();
                document.body.classList.remove("modal-vue--open");
            } else {
                this.showCancelWarning = true;
                document.body.classList.add("modal-vue--open");
            }
            this.$emit('passes-validation-changed', true)
        },
        clearFormData() {
            this.addressData = {
                firstname: '',
                last_name: '',
                address: '',
                house_number: '',
                address2: '',
                postcode: '',
                city: '',
                id_country: this.defaultCountryId,
                phone: '',
                default_address: false
            };

            this.$emit('clear-address-copy-data');
        }
    },
    watch: {
        addNewInvoiceAddress: {
            immediate: true,
            handler(address) {
                if (address) {
                    document.getElementsByClassName('checkout-address__title')[0].scrollIntoView({
                        behavior: 'smooth'
                    });
                    setTimeout(function() {
                        document.getElementById('input_first_name').focus();
                    }, 500);
                }
            }
        },
        addNewAddress: {
            immediate: true,
            handler(address) {
                if (address) {
                    document.getElementsByClassName('checkout-address__title')[0].scrollIntoView({
                        behavior: 'smooth'
                    });
                    setTimeout(function() {
                        document.getElementById('input_first_name').focus();
                    }, 500);
                }
            }
        },
        selectedAddress: {
            immediate: true,
            handler(address) {
                this.$emit("selected-delivery-address-changed", address);

                if  (address) {
                    this.unsetShippingMessages();
                    this.setNoShippingOrUpliftMessage(address);
                    this.changeOrderAddress();
                }
            }
        },
        selectedInvoiceAddress: {
            immediate: true,
            handler(address) {
                this.$emit("selected-invoice-address-changed", this.matchingInvoiceAddress ? this.selectedAddress : address);

                if (address) {
                    this.changeOrderAddress();
                }
            }
        },
        matchingInvoiceAddress: {
            immediate: true,
            handler(isMatching) {
                if (isMatching) {
                    this.selectedInvoiceAddress = JSON.parse(JSON.stringify(this.selectedAddress));
                }

                if (
                    (isMatching && this.selectedAddress) ||
                    ((! isMatching) && this.selectedInvoiceAddress)
                ) {
                    this.changeOrderAddress();
                }
            }
        },
        editDeliveryAddress: {
            handler(addressData) {
                if (!addressData) {
                    return;
                }

                this.pushGAEvent("begin_edit_delivery_address", {});
            }
        },
        editInvoiceAddress: {
            handler(addressData) {
                if (!addressData) {
                    return;
                }

                document.getElementsByClassName('checkout-address__title')[0].scrollIntoView({
                    behavior: 'smooth'
                });

                if (document.getElementById('input_first_name')) {
                    document.getElementById('input_first_name').focus();
                }

                this.pushGAEvent("begin_edit_invoice_address", {});
            }
        },
        addressCopyData: function(val) {
            if (val !== {}) {
                this.addressData = val;
            }
        },
        passesValidation: {
            immediate: true,
            handler(passed) {
                this.$emit("passes-validation-changed", passed);
            }
        }
    }
};
</script>
